export enum PrescriptionEventType {
  Reminder = 'Reminder',
}
